import './InlineAuthForm.sass';

import React, { FC, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useTranslator } from '$hooks';
import { Button } from '$uikit';
import { authSelector } from '$store/auth';
import { profileActions } from '$store/profile';
import { AuthPopoverState } from '$store/models';

export const InlineAuthForm: FC<{ isInfoHidden?: boolean; isModel?: boolean }> = ({
  isInfoHidden,
  isModel = true,
}) => {
  const t = useTranslator();
  const dispatch = useDispatch();
  const { isLogged } = useSelector(authSelector);

  const signInHandle = useCallback(() => {
    dispatch(profileActions.setAuthPopoverState(AuthPopoverState.LOGIN));
  }, []);

  if (isLogged) {
    return null;
  }

  return (
    <div className="InlineAuthForm" onClick={signInHandle}>
      {!isInfoHidden && (
        <div className="InlineAuthForm__info">
          <div className="InlineAuthForm__title">
            {t(isModel ? 'inline_auth_form_title_new' : 'inline_auth_form_title')}
          </div>
        </div>
      )}
      <div className="InlineAuthForm__footer">
        <Button stretched flare>
          {t('sign_in_button')}
        </Button>
      </div>
    </div>
  );
};
